//Reset data
export const RESET = "AUTH_LOGIN_RESET"


//Loading
export const SET_SHOW_LOADING = "AUTH_LOGIN_SET_SHOW_LOADING"
export const SET_HIDE_LOADING = "AUTH_LOGIN_SET_HIDE_LOADING"

//Message
export const SET_MESSAGE = "AUTH_LOGIN_SET_MESSAGE"
export const SET_IS_SUCCESS = "AUTH_LOGIN_SET_IS_SUCCESS"
export const SET_IS_ERROR = "AUTH_LOGIN_SET_IS_ERROR"

export const SET_ITEMS = "AUTH_LOGIN_SET_ITEMS"
export const SET_SHOW_MESSAGE = "AUTH_LOGIN_SET_SHOW_MESSAGE"
export const SET_HIDE_MESSAGE = "AUTH_LOGIN_SET_HIDE_MESSAGE"

//Data
export const SET_IS_LOGIN = "AUTH_SET_IS_LOGIN"
export const SET_ID = "AUTH_LOGIN_SET_ID"

//Modal
